import { Svg } from '@repo/ui';

import ErrorBaseView, { ErrorBaseViewController } from '@/components/tax-refund/common/view/ErrorView/ErrorBaseView';

interface Props {
  onPrimaryButtonClick: () => void;
}

const UnexpectedError = ({ onPrimaryButtonClick }: Props) => {
  const errorBaseViewController: ErrorBaseViewController = {
    graphic: <Svg src="icg_exclamation-mark_md.svg" width={80} height={80} />,
    title: '예상하지 못한 문제가 발생했어요',
    description: (
      <>
        이용에 불편을 드려 죄송합니다.
        <br />
        문의해주시면 최선을 다해 문제를 해결할게요.
      </>
    ),
    primaryButtonText: '문의하기',
    onPrimaryButtonClick: onPrimaryButtonClick,
    primaryButtonVariant: 'tonal-secondary'
  };

  return <ErrorBaseView viewController={errorBaseViewController} />;
};

export default UnexpectedError;
